import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=67bf8b02&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=ts"
export * from "./Invitation.vue?vue&type=script&lang=ts"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=67bf8b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf8b02",
  null
  
)

export default component.exports